import UiPageListSearch from "./UiPageListSearch";
import UiPageListSearch_DynamicSearchItem from "./UiPageListSearch_DynamicSearchItem";
import { EnumUiDynamicSearchItemType } from "./EnumUiDynamicSearchItemType";
import { EnumCompare } from "./EnumCompare";
import { EnumCompanyBusinessCardType, EnumCompanyBusinessCardTypeOption } from "./EnumCompanyBusinessCardType";

/**
 * 单位页列表-搜索条件分页列表-搜索条件
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPageListSearchCompanyBusinessCardUnit extends UiPageListSearch {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 类型
     */
    Type?: EnumCompanyBusinessCardType;
    /**
     * 公司Id
     */
    CompanyId?: string;
}

/**
 * 单位页列表-搜索条件分页列表-搜索条件-表单校验
 */
export const DtoPageListSearchCompanyBusinessCardUnitRules = {
}

/**
 * 单位页列表-搜索条件分页列表-搜索条件-动态搜索配置项
 */
export const DtoPageListSearchCompanyBusinessCardUnitDynamicSearchItems: UiPageListSearch_DynamicSearchItem[]  = [
]
